import { Injectable } from '@angular/core';
import { MetaInterfaceServiceProvider } from '@ep-om/project/state/metaInterfaces/metaInterfaces.provider.service';
import { persistedEntityCount } from '@persistence/akita-persist-storage';
import { isRegisteredPersistedStore } from '@persistence/persist-registry';

/**
 * Risponde a due domande sulla persistenza di uno store Akita che il sync realtime non puo'
 * risolvere da solo, cosi' reconcilePersistedCursors distingue un cursore davvero "avanti rispetto
 * ai dati" da uno store che non poteva avere dati (mai persistito, o idratazione persa).
 * E' un servizio (e non funzioni di modulo) per poterlo sostituire con un fake nei test.
 */
@Injectable({
  providedIn: 'root',
})
export class PersistedStoreRegistry {
  constructor(private metaInterfaceProvider: MetaInterfaceServiceProvider) {}

  /** true se lo store ha una persistState: registrata (@PersistedStoreConfig) o dinamica (meta interfaccia). */
  isPersisted(storeName: string): boolean {
    return isRegisteredPersistedStore(storeName) || this.metaInterfaceProvider.isPersistedStore(storeName);
  }

  /** Entita' che IDB conteneva per lo store all'avvio (fotografia dello snapshot, non aggiornata). */
  persistedEntityCountAtBoot(storeName: string): number {
    return persistedEntityCount(storeName);
  }
}
